import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { lastValueFrom } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AnalyticsComponent } from '../analytics/analytics.component';


import { ApiResponsePagination, PipelineRunsService } from '../services/pipelineruns.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatInputModule,
    MatFormFieldModule,
    HttpClientModule,
    MatIconModule,
    MatOption,
    MatSelect,
    FormsModule,
    RouterLink,
    NgxChartsModule,
    AnalyticsComponent
  ],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['error', 'pipelinerun', 'pipeline', 'project', 'username' , 'gh_id', 'branch', 'lane', 'timestamp'];
  dataSource!: MatTableDataSource<any>;

  projects: string[] = [];
  selectedProject: string = '';

  branches: string[] = [];
  selectedBranch: string = '';

  pipelines: string[] = [];
  selectedPipeline: string = '';

  @ViewChild(MatSort) sort!: MatSort;

  constructor(private pipelineRunsService: PipelineRunsService) { }

  async ngOnInit(): Promise<void> {
    let response = await lastValueFrom(this.pipelineRunsService.getPipelineRuns());
    let dataArray = [];
    if(response != null) {
      if (response.data != null) {
        for(let i = 0; i < response.data.length; i++) {
          if(response.data[i].pipelinerun.startsWith('nightly') && response.data[i].username == "") {
            response.data[i].username = "scheduled";
          } else if (!response.data[i].pipelinerun.startsWith('nightly') && response.data[i].username == "" && response.data[i].gh_id == "") {
            response.data[i].username = "manual";
          }
        }
        dataArray = response.data;
      }
    }
    this.dataSource = new MatTableDataSource(dataArray);
    this.dataSource.sort = this.sort;

    await this.loadBranchOptions();
    await this.loadProjectOptions();
    await this.loadPipelineOptions();

  }

  ngAfterViewInit(): void {

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async loadProjectOptions(): Promise<void> {
    this.selectedProject = '';
    this.projects = [];
    this.projects.push("");
    let response = await lastValueFrom(this.pipelineRunsService.getProjects())
    if(response != null) {
      if (response.data != null) {
        for(let i = 0; i < response.data.length; i++) {
          this.projects.push(response.data[i].project)
        }
      }
    }
  }

  async loadBranchOptions(): Promise<void> {
    this.selectedBranch = '';
    this.branches = [];
    this.branches.push("");
    let response = await lastValueFrom(this.pipelineRunsService.getBranches())
    if(response != null) {
      if (response.data != null) {
        for(let i = 0; i < response.data.length; i++) {
          this.branches.push(response.data[i].branch)
        }
      }
    }
  }

  async loadPipelineOptions(): Promise<void> {
    this.selectedPipeline = '';
    this.pipelines = [];
    this.pipelines.push("");
    let response = await lastValueFrom(this.pipelineRunsService.getPipelines())
    if(response != null) {
      if (response.data != null) {
        for(let i = 0; i < response.data.length; i++) {
          this.pipelines.push(response.data[i].pipeline)
        }
      }
    }
  }

  async onProjectChange(): Promise<void> {
    await this.loadBranchOptions();
    await this.loadPipelineOptions();
    await this.loadData("project", this.selectedProject);
  }

  async onBranchChange(): Promise<void> {
    await this.loadProjectOptions();
    await this.loadPipelineOptions();
    await this.loadData("branch", this.selectedBranch);
  }

  async onPipelineChange(): Promise<void> {
    await this.loadProjectOptions();
    await this.loadBranchOptions();
    await this.loadData("pipeline", this.selectedPipeline);
  }

  async loadData(column: string, value: string): Promise<void> {
    let response: ApiResponsePagination;
    if(value != "") {
      switch (column) {
        case "branch":
          response = await lastValueFrom(this.pipelineRunsService.getByColumn(column, value));
          break;
        case "project":
          response = await lastValueFrom(this.pipelineRunsService.getByColumn(column, value));
          break;
        case "pipeline":
          response = await lastValueFrom(this.pipelineRunsService.getByColumn(column, value));
          break;
        default:
          response = await lastValueFrom(this.pipelineRunsService.getPipelineRuns());
      }
    } else {
      response = await lastValueFrom(this.pipelineRunsService.getPipelineRuns());
    }
    let dataArray = [];
    if(response != null) {
      if (response.data != null) {
        dataArray = response.data;
      }
    }
    this.dataSource = new MatTableDataSource(dataArray);
    this.dataSource.sort = this.sort;
  }
}